import React, { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";

// <img> with shimmer placeholder, fade-in and one automatic retry (fresh Discord URL).
export const SmartImg = ({ src, alt = "", className = "", wrapperClassName = "", eager = false, ...rest }) => {
    const [attempt, setAttempt] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const [failed, setFailed] = useState(false);

    useEffect(() => { setAttempt(0); setLoaded(false); setFailed(false); }, [src]);

    if (!src || failed) {
        return (
            <div className={`w-full h-full flex items-center justify-center text-[var(--tb-muted)] ${wrapperClassName}`} data-testid="smart-img-fallback">
                <ImageOff className="w-5 h-5" />
            </div>
        );
    }

    const current = attempt === 0 ? src : `${src}${src.includes("?") ? "&" : "?"}retry=${attempt}`;
    return (
        <div className={`relative w-full h-full ${wrapperClassName}`}>
            {!loaded && <div className="absolute inset-0 animate-pulse bg-[var(--tb-surface-2)]" aria-hidden="true" />}
            <img
                {...rest}
                src={current}
                alt={alt}
                loading={eager ? "eager" : "lazy"}
                fetchpriority={eager ? "high" : undefined}
                decoding="async"
                onLoad={() => setLoaded(true)}
                onError={() => (attempt < 2 ? setAttempt(attempt + 1) : setFailed(true))}
                className={`${className} transition-opacity duration-300 ${loaded ? "opacity-100" : "opacity-0"}`}
            />
        </div>
    );
};
